module.exports = __webpack_public_path__ + "static/images/link.72bb805d1d03b599dc859ac9fde99cff.svg";